module.exports = __webpack_public_path__ + "static/img/box3-config.a9760ae.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/box3-config.png
// module id = yRhi
// module chunks = 1